import { createBrowserHistory } from "history";
import { Switch, Route, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import CommonComponant from "./CommonComponant";
import { ReactFlowProvider } from "reactflow";
import ImportOptions from "../Contacts/ImportOption";
import Account from "../Account/Account";
import Contact from "../Contacts/Contact";
import Pricing from "./Pricing";
import Statistics from "./Statistics";
import Schedule from "../Schedule/Schedule";
import BulkMailVerification from "./BulkMailVerification";
import WarmUpAnalytics from "./WarmUpAnalytics";
import TemplatesComponent from "./TemplatesComponent";
import CalendlyLoad from "./CalendlyLoad";
import ListTable from "./ListTable";
import CreateAccount from "./CreateAccount";
import TeamLoad from "./TeamsLoad";
import Goals from "./Goals";
import GoalDetails from "./GoalDetails";
import GoalContacts from "./GoalContacts";
import EmailAccounts from "./EmailAccounts";
import Integration from "./Integration";
import Verify from "../SignUp/Verify";
import MicroSoftVerify from "./MicrosoftLoad";
import ApiDocumentation from "./ApiDocumentation";
import EmailWarmUpCopy from "./EmailWarmUpCopy";
import NewCampaignCopy from "./NewCampaignCopy";
import Unibox from "./Unibox";
import AllCampaigns from "./AllCampaigns";
import UnSubScribe from "../UnsubScribe/UnSubScribe";
import SignatureBuilder from "./SignatureBuilder";
export default function DashBoard() {
  var history = createBrowserHistory();
  return (
    <ReactFlowProvider>
      <Router history={history}>
        <Switch>
          <Route exact path="/Email/accounts">
            <CommonComponant Componant={EmailAccounts} />
          </Route>
          <Route exact path="/integrations">
            <CommonComponant Componant={Integration} />
          </Route>
          <Route exact path="/Email/accounts/settings">
            <CommonComponant Componant={EmailAccounts} />
          </Route>
          <Route exact path="/DashBoard/Campaign">
            <CommonComponant Componant={AllCampaigns} />
          </Route>
          <Route  exact path="/All-Campaign/New-Campaign">
            <CommonComponant Componant={NewCampaignCopy} />
          </Route>
          <Route exact path="/All-Campaign/Schedule">
            <CommonComponant Componant={Schedule} />
          </Route>
          <Route exact path="/All-Campaign/Templates">
            <CommonComponant Componant={TemplatesComponent} />
          </Route>
          {/* <Route exact path="/Contacts/Import-options" >
            <CommonComponant Componant={DragTest} />
          </Route> */}
          <Route exact path="/Contacts/Import-options">
            <CommonComponant Componant={ImportOptions} />
          </Route>
          <Route exact path="/UnSubscribe/:mail/:id" component={UnSubScribe}></Route>
          <Route exact path="/Contacts/:id">
            <CommonComponant Componant={Contact} />
          </Route>
          <Route exact path="/Pricing">
            <CommonComponant Componant={Pricing} />
          </Route>
          <Route exact path="/Goals">
            <CommonComponant Componant={Goals} />
          </Route>
          <Route exact path="/Goals/:id">
            <CommonComponant Componant={GoalDetails} />
          </Route>
          <Route exact path="/Signature/:id/:from">
            <CommonComponant Componant={SignatureBuilder} />
          </Route>
          <Route exact path="/Goal/leads/:id">
            <CommonComponant Componant={GoalContacts} />
          </Route>
          <Route exact path="/Emailverify">
            <CommonComponant Componant={BulkMailVerification} />
          </Route>
          <Route exact path="/BulkMailVerification">
            <CommonComponant Componant={BulkMailVerification} />
          </Route>
          <Route exact path="/MailWarmUp">
            <CommonComponant Componant={EmailWarmUpCopy} />
          </Route>
          <Route exact path="/Replies">
            <CommonComponant Componant={Unibox} />
          </Route>
          <Route exact path="/Statistics">
            <CommonComponant Componant={Statistics} />
          </Route>
          <Route exact path="/Accounts">
            <CommonComponant Componant={Account} />
          </Route>
          <Route path="/Accounts/*">
            <CommonComponant Componant={Account} />
          </Route>
          <Route path="/api/documentation">
            <CommonComponant Componant={ApiDocumentation} />
          </Route>
          <Route exact path="/Lists">
            <CommonComponant Componant={ListTable} />
          </Route>
          <Route
            exact
            path="/Calendly-Verify/*"
            component={CalendlyLoad}
          ></Route>
          <Route
            exact
            path="/Microsoft-Verify/:status/:message"
            component={MicroSoftVerify}
          ></Route>

          <Route exact path="/Teams-Verify/*" component={TeamLoad}></Route>
          <Route
            exact
            path="/Account-Verify/*"
            component={CreateAccount}
          ></Route>
          <Route exact path="/Warmup-Analytics">
            <CommonComponant Componant={WarmUpAnalytics} />
          </Route>
          <Route exact path="/verify/:id" component={Verify}></Route>
          <Redirect from="" to="/Email/accounts" />
        </Switch>
      </Router>
    </ReactFlowProvider>
  );
}
